<template lang="pug">
global-form-group.nse-textarea(:title="field.title" :field-name="field.name")
    textarea.nse-textarea(@input="changeInput" v-model="content" :rows="maxLine")
    div.row-textarea
        div.text-inspiration
            a(href="javascript:" @click="showInspiration = true") {{ LANG.FIND_INSPIRATION }}

        div.text-maxline
            | {{ LANG.ROW }}: {{ currentRowCount }}/{{ maxLine }}
    //div.desc(v-html="field.description")

    a-modal(
        centered
        v-model:visible="showInspiration"
        :footer="false"
        class="popup-send-email"
        width="400px"
    )
        inspiration(@input="selectedInspiration" :poster_style="poster_style")
</template>

<style lang="scss">
.nse-textarea {
    .row-textarea {
        display: flex;
        justify-content: space-between;
    }
	textarea {
		font-family: "Arial";
	}
    .text-inspiration {
        font-size: 12px;
    }
	.text-maxline {
		text-align: right;
		font-size: 12px;
	}
}
</style>

<script>
import GlobalFormGroup from "../../GlobalFormGroup";
import Inspiration from "@/components/settings_element/textarea/Inspiration";
import {excludeSpecial} from "@/commons/TextParse";

export default {
	name: "NseTextarea",
	components: {Inspiration, GlobalFormGroup},
	props: {
		field: {},
		selected: {},
		selected_full: {},
	},

	data() {
		return {
			timeout_input: false,
			content_tmp: '',
            showInspiration: false
		}
	},

	computed: {
        poster_style() {
            return this.selected_full.poster_style.value;
        },
		currentRowCount () {
			var lines = this.content.split("\n");
			return lines.length
		},
		maxLine() {
			var ml = 0;
			try {
				ml = this.selected_full.poster_size.text_saying.max_text_lines;
			} catch ( e) {
				ml = 0
			}
			return ml;
		},
		content: {
			get() {
				return this.selected && this.selected.value ? this.selected.value : "";
			},

			set(nv) {
				if (this.field.name === 'text_messages') {
					var lines = nv.split("\n");
					try {
						var ml = this.maxLine;
						if (ml < lines.length) {
							lines.length = ml;
						}
					} catch (e) {
					}
					this.content_tmp = lines.join("\n");
				} else {
					this.content_tmp = nv;
				}
			}
		}
	},

	methods: {
		changeInput() {
			var self = this;

			if (this.timeout_input) {
				clearTimeout(this.timeout_input);
				this.timeout_input = false;
			}

			this.timeout_input = setTimeout(() => {
				self.changeSelect();
			}, 50);
		},

        selectedInspiration(content) {
            this.content_tmp = content;
            this.changeSelect();
            this.showInspiration = false;
        },

		changeSelect() {
			var self = this;
			var o = Object.assign({}, this.field, {
				value: excludeSpecial(self.content_tmp)
			});
			this.$emit('select', o);
		}
	}
}
</script>
